export async function handleShare(title: string, text: string, url: string) {
    const shareData = {
        title,
        text,
        url,
    };

    if (navigator.share) {
        try {
            await navigator.share(shareData);
        } catch {}
    } else {
        try {
            await navigator.clipboard.writeText(window.location.href);
            alert("Link copied to clipboard!");
        } catch {}
    }
}

export const shareToFacebook = (url: string): void => {
    if (!url) return;

    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url,
    )}`;

    const width = 600;
    const height = 600;
    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;

    window.open(
        shareUrl,
        "facebook-share-dialog",
        `width=${width},height=${height},left=${left},top=${top}`
    );
};
